<script setup lang="ts">
import { computed } from "vue"
import { useErrorStore } from "@stores/models/error.store"

const errorStore = useErrorStore()

const visible = computed(() => errorStore.showIntegrityErrorDialog)

const handleRetry = () => {
  errorStore.retry()
}
</script>

<template>
  <div
    v-if="visible"
    class="animate-fadeIn fixed top-0 left-0 z-[1000] flex h-screen w-screen items-center justify-center bg-black/50 px-4"
  >
    <div class="animate-slideIn w-full max-w-[500px] rounded-lg bg-white p-4 shadow-xl sm:p-6">
      <div class="text-pblue mb-3 text-lg font-semibold sm:mb-4 sm:text-xl">
        Eroare de comunicare
      </div>
      <div class="text-pblue mb-5 text-sm leading-relaxed sm:mb-6 sm:text-base">
        A apărut o problemă în comunicarea cu serverul. Vă rugăm să reîncercați.
      </div>
      <div class="flex flex-col gap-4 sm:flex-row sm:justify-end sm:gap-3">
        <button
          class="bg-pcyan hover:bg-pcyan/90 cursor-pointer rounded-full border-none px-6 py-2 text-sm font-medium text-white uppercase transition-all"
          @click="handleRetry"
        >
          Reîncarcă pagina
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.animate-fadeIn {
  animation: fadeIn 0.2s ease-in-out;
}

.animate-slideIn {
  animation: slideIn 0.3s ease-out;
}
</style>
